module.exports = __webpack_public_path__ + "img/banner1.448a1505.png";